module.exports = __webpack_public_path__ + "img/subject_17.b5deb783.jpg";